export const ERROR_TRANSLATIONS: Record<string, string> = {
  'User not found': 'Používatel nenájdený.',
  'phoneNumber must be a valid phone number':
    'Telefónne číslo musí byť platné.',
  'User with this phone number does not exist.':
    'Používateľ s týmto telefónnym číslom neexistuje.',
  'Phone number must be unique': 'Telefónne číslo je už registrované.',
  'The verification code you entered is incorrect. Please check the code and try again. Remaining attempts: 2.':
    'Zadaný overovací kód nie je správny. Skontrolujte kód a skúste to znova. Zostávajúce pokusy: 2.',
  'The verification code you entered is incorrect. Please check the code and try again. Remaining attempts: 1.':
    'Zadaný overovací kód nie je správny. Skontrolujte kód a skúste to znova. Zostávajúce pokusy: 1.',
  'The verification code has expired. Please request a new verification code.':
    'Overovací kód vypršal. Požiadajte o nový overovací kód.',
  'Internal server error': 'Interná chyba servera.',
}

export const getErrorMessage = (err: any): string => {
  if (err?.error?.message) {
    const apiMessage = err.error.message
    if (Array.isArray(apiMessage)) {
      const translatedMessages = apiMessage.map(
        (msg) => ERROR_TRANSLATIONS[msg] || msg
      )
      return translatedMessages.join('\n')
    } else {
      return ERROR_TRANSLATIONS[apiMessage] || apiMessage
    }
  }

  if (err?.message) {
    return ERROR_TRANSLATIONS[err.message] || err.message
  }

  return 'Nastala neznáma chyba.'
}
